/**
 * SingleSearchModal
 *
 * View that handles the single search modal
 *
 * @return {view}
 */

OT.createNS('OT.Redesign.Views.Modals');

(function ($) {

    var positionModal = function ($root, $reserveLink) {

        var $window = $(window),
            $resultsSet = $root.parents('.search-results-container'),
            $modal = $root.find('#single-search-modal'),
            isMobile = $window.width() <= 640, // todo: is there a better way to find this out?
            relativeReserveLinkRight = $reserveLink.offset().left + $reserveLink.width() - $root.parent().offset().left,
            modalPosition = getModalPositionElements(isMobile, $resultsSet.offset().top, relativeReserveLinkRight, $window, $reserveLink);

        updateModalCssPositionInformation($root, $modal, modalPosition);
        updateArrowDisplay($root, relativeReserveLinkRight, modalPosition, isMobile);
    };

    var getModalPositionElements = function (isMobile, resultsSetTopOffset, relativeReserveLinkRight, $window, $reserveLink) {

        // todo: don't use hardcoded values here

        var width = getModalWidth(isMobile, $window.width());
        var top = $reserveLink.offset().top + $reserveLink.height() - resultsSetTopOffset + 10;
        var left = relativeReserveLinkRight - width + 10;
        var bottomBoundary = $window.scrollTop() + $window.height() - resultsSetTopOffset - 200; 
        var showModalAboveReserveLink = top > bottomBoundary;

        top = showModalAboveReserveLink ? getAdjustedModalTopWhenShowingAboveReserveLink(top, isMobile) : top;
        left = coerseLeftSoModalDoesntAppearOffScreen(left);

        return {
            top: top,
            left: left,
            width: width,
            showModalAboveReserveLink: showModalAboveReserveLink
        };
    };

    var getModalWidth = function (isMobile, windowWidth) {
        if (isMobile) {
            return windowWidth - 20;
        }
        return 660;
    };

    var getAdjustedModalTopWhenShowingAboveReserveLink = function(originalTop, isMobile) {
        return originalTop - (isMobile ? 215 : 160); // todo: replace these hardcoded numbers with calculated values (from pop-up height for example)
    };

    var coerseLeftSoModalDoesntAppearOffScreen = function (originalLeft) {
        return Math.max(-20, originalLeft);
    };

    var updateModalCssPositionInformation = function($root, $modal, modelPosition) {
        $root.css({
            'top': modelPosition.top,
            'left': modelPosition.left,
            'width': modelPosition.width
        });

        $modal.css({
            'width': modelPosition.width
        });
    };

    var updateArrowDisplay = function ($root, relativeReserveLinkRight, modalPosition, isMobile) {

        var $arrows = $root.find('.icon-single-search-modal'),
            $upArrow = $root.find('.icon-single-search-modal.top'),
            $downArrow = $root.find('.icon-single-search-modal.bottom');

        $arrows.css({
            'left': relativeReserveLinkRight - modalPosition.left - 70
        });

        if (modalPosition.showModalAboveReserveLink) {
            $upArrow.hide();
            $downArrow.css({ 'bottom': isMobile ? -179 : -131 }); // todo: I don't like these magic numbers that rely on the css so directly
            $downArrow.show();
        } else {
            $upArrow.show();
            $downArrow.hide();
        }
    };

    var registerListenersToHideModal = function ($el) {
        $el.click(function(e) {
            e.stopPropagation();
        });
        $(document).on('click', function() {
            $el.hide();
        });
        $(window).resize(function() {
            $el.hide();
        });
        OT.Events.on('singleSearchModal:cleared', function() {
            $el.hide();
        });
    };

    /*var attemptBooking = function (data, restaurantId) {

        var csrfToken = $('input[name=__RequestVerificationToken]').val();
        var dateTime = data.datetime;
        var covers = data.covers;

        $.ajax("/s/LocalBooking/AttemptBooking", {
            type: "post",
            data: {
                DateTime: dateTime,
                RestaurantId: restaurantId,
                Covers: covers,
                '__RequestVerificationToken': csrfToken
            },
            dataType: "html",
            success: function(result) {
                location.href = $.parseJSON(result).ChecksummedUrl;
            }
            //todo: figure out what to do in case of error
        });
    };*/

    var sendToResProfile = function (data, restaurantId, promoId, ref, profileUrl) {
        var profileUrlWithoutQueryString = profileUrl.split("?")[0];
        var url = profileUrlWithoutQueryString + "?p=" + data.covers + "&d=" + data.datetime;
        if (promoId)
        {
            url += "&pid=" + promoId;
        }

        if (ref)
        {
            url += "&ref=" + ref;
        }
        location.href = url;
    };

    var clearOtherSingleSearchModals = function() {
        OT.Events.fire('singleSearchModal:cleared');
    };

    var setPreSelectedDateTime = function ($dtp, preSelectedIsoDateTime, isLunchMode, isDinnerMode) {

        var preSelectedDateTime = moment(preSelectedIsoDateTime);
        var now = moment();

        var earliestBookingTime;
        if (preSelectedDateTime > now) {
            earliestBookingTime = preSelectedDateTime.hours(now.hours()).minutes(now.minutes()).seconds(0);
        } else {
            earliestBookingTime = now;
        }

        if (isLunchMode) {
            overrideDateAndTimeToLunch($dtp, earliestBookingTime);
        } else if (isDinnerMode) {
            overrideDateAndTimeToDinner($dtp, earliestBookingTime);
        }
    };

    var overrideDateAndTimeToLunch = function ($dtp, earliestBookingTime) {
        var nextLunchSlot = getNextValidTimeForLunch(earliestBookingTime);
        setTime($dtp, nextLunchSlot);
    };

    var overrideDateAndTimeToDinner = function ($dtp, earliestBookingTime) {
        var nextDinnerSlot = getNextValidTimeForDinner(earliestBookingTime);
        setTime($dtp, nextDinnerSlot);
    };

    var setTime = function($dtp, datetime) {
        $dtp.OTdtp("set", { searchBox: false, date: datetime.format('YYYY-MM-DD'), time: datetime.format('HH:mm') });
    };

    var getNextValidTimeForLunch = function(earliestBookingTime) {
        var earliestTime = moment(earliestBookingTime);
        var targetTime = moment(earliestTime).hours(12).minutes(0);

        var targetTimeIsInTheFuture = targetTime > earliestTime;
        if (targetTimeIsInTheFuture) {
            return targetTime;
        }

        var lunchCutOff = moment(earliestTime).hours(15).minutes(0);
        var tooLateForLunchOnThatDay = earliestTime > lunchCutOff;
        if (tooLateForLunchOnThatDay) {
            return targetTime.add('days', 1);
        }

        var nextSlotFromNow = OT.Search.Helpers.DateUtilities.roundToNextHalfHour(earliestTime);
        return nextSlotFromNow;
    };

    var getNextValidTimeForDinner = function(earliestBookingTime) {
        var earliestTime = moment(earliestBookingTime);
        var targetTime = moment(earliestTime).hours(19).minutes(0);

        var targetTimeIsInTheFuture = targetTime > earliestTime;
        if (targetTimeIsInTheFuture) {
            return targetTime;
        }
        var dinnerCutOff = moment(earliestTime).hours(22).minutes(30);
        var tooLateForDinnerToday = earliestTime > dinnerCutOff;
        if (tooLateForDinnerToday) {
            return targetTime.add('days', 1);
        }

        var nextSlotFromNow = OT.Search.Helpers.DateUtilities.roundToNextHalfHour(earliestTime);
        return nextSlotFromNow;
    };

    var setRestaurantName = function($el, restaurantName) {
        $el.find("#restaurant-name").text(restaurantName); // todo: add "Reserve at"
    };

    OT.Redesign.Views.Modals.SingleSearchModal = Backbone.ViewManager.BaseView.extend({
        el: '#single-search-modal-placeholder',

        initialize: function () {
            var self = this;

            this.$el.hide();
            registerListenersToHideModal(self.$el);

            self.$dtp = self.$(".dtp-picker");

            OT.Events.on('dtp:search', function (target, data) {
                if (self.$dtp[0] === data.sender[0]) {
                    self.search(data);
                }
            });
        },

        display: function(data) {
            var preSelectedDateTime = this.$el.data('pre-selected-date');
            this.restaurantId = data.restaurantId;
            this.promoId = data.promoId;
            this.ref = data.ref;
            this.profileUrl = data.profileUrl;

            clearOtherSingleSearchModals();
            setRestaurantName(this.$el, data.restaurantName);
            setPreSelectedDateTime(this.$dtp, preSelectedDateTime, data.isLunchLink, data.isDinnerLink);
            positionModal(this.$el, data.$reserveLink);

            this.$el.show();
        },

        search: function (data) {
            sendToResProfile(data, this.restaurantId, this.promoId, this.ref, this.profileUrl);
        }
    });
})(jQuery);
